<template>
	<FormGroupBox
		:icon="tripIcon"
		:title="`${$t('bookings.service')} #${model.serviceNumber}`"
		:class="{rideSelected:isRideSelected}"
	>
		<template v-if="model.supplierConfirmation  != 'pending' && operatedBy == 'sc' " #append-title>
			<b-badge :variant="supplierConfirmationStatus.class">
				{{supplierConfirmationStatus.text}}
			</b-badge>
		</template>
		<template v-else-if="operatedBy == 'sc' && model.supplierConfirmation == 'pending' && model.status != 'partialCancellation'" #append-title>
			<b-dropdown
				:text="$t('bookings.acceptReject') "
				size="md"
				v-show="!isMobile"
				variant="outline-primary"
				class="m-2"

			>
				<b-dropdown-item @click="saveSupplierConfirmation('confirmed')">
					<md-icon class="text-success" :icon="'task_alt'"> </md-icon>
					{{$t('bookings.acceptService')}}
				</b-dropdown-item>

				<b-dropdown-divider></b-dropdown-divider>

				<b-dropdown-item @click="saveSupplierConfirmation('rejected')" v-if="model.status=== 'active'">
					<md-icon class="text-danger" :icon="'clear'"> </md-icon>{{$t('bookings.rejectService')}}
				</b-dropdown-item>
			</b-dropdown>
			<!-- <b-button @click="() => saveSupplierConfirmed(false)" size="sm" variant="warning" class="ml-2" v-else><md-icon icon="error_outline"/> {{$t('bookings.rejectService')}}</b-button> -->

		</template>
		<b-form-row
			v-if="domainPointOfsale !== false"
			class="justify-content-end"
		>
			<b-badge variant="primary"
				>{{ $t("global.pos") }} {{ domainPointOfsale }}</b-badge
			>
		</b-form-row>
		<b-form-row class="justify-content-end">
			<b-form-group class="col-md-3" :label="$t('bookings.status')">
				<b-form-select
					v-if="isNew"
					size="sm"
					v-model="model.status"
					:options="transportStatusOpts"
				/>
				<h4 v-else>
					<b-badge :variant="statusVariant" size="md">
						{{ statusLabel }}
					</b-badge>
					<b-button
						@click="showStatusEvidenceModal = true"
						v-if="
							model.status === 'noShow' || model.status === 'done'
						"
						size="sm"
						variant="warning"
						><md-icon icon="visibility"
					/></b-button>
				</h4>
			</b-form-group>
		</b-form-row>

		<div class="text-center" v-show="isMobile" v-if="operatedBy == 'sc' && model.supplierConfirmation == 'pending' && model.status != 'partialCancellation'">
			<b-dropdown
				:text="$t('bookings.acceptReject') "
				v-show="isMobile"
				variant="outline-primary"
				class="m-2"
				menu-class="w-100"
				block
			>
				<b-dropdown-item @click="saveSupplierConfirmation('confirmed')">
					<md-icon class="text-success" :icon="'task_alt'"> </md-icon>
					{{$t('bookings.acceptService')}}
				</b-dropdown-item>

				<b-dropdown-divider></b-dropdown-divider>

				<b-dropdown-item @click="saveSupplierConfirmation('rejected')" v-if="model.status=== 'active'">
					<md-icon class="text-danger" :icon="'clear'"> </md-icon>{{$t('bookings.rejectService')}}
				</b-dropdown-item>
			</b-dropdown>
		</div>


		<b-form-row class="justify-content-between">
			<b-form-group :label="$t('bookings.origin')" style="width: 45%" :class="{ 'col-5': !isMobile, 'col-12': isMobile, 'mt-2': isMobile, 'mb-2': isMobile }">
				<b-input-group v-if="!pickupEdit" size="sm">
					<b-form-input
						type="text"
						size="sm"
						v-model="model.pickup.name"
						readonly
						required
					/>
					<template #prepend>
						<b-button
							v-if="pickupLocationUrl"
							:href="pickupLocationUrl"
							target="_blank"
							variant="success"
							size="sm"
						>
							<md-icon :icon="pickupTypeIcon" />
						</b-button>
						<b-input-group-text v-else
							><md-icon :icon="pickupTypeIcon"
						/></b-input-group-text>
					</template>
					<template v-if="!unableEdit" #append>
						<b-button variant="primary" @click="pickupEdit = true"
							><md-icon icon="edit"></md-icon
						></b-button>
					</template>
				</b-input-group>

				<vue-typeahead-bootstrap
					v-else
					showAllResults
					size="sm"
					:placeholder="$t('global.search')"
					v-model="pickupSearch"
					:serializer="place => place.name"
					:data="pickupData"
					@hit="selected => setPlace('pickup', selected)"
				>
					<template #suggestion="{ data, htmlText }">
						<span v-html="htmlText"></span><br /><small>{{
							data.address
						}}</small>
					</template>
					<template #prepend>
						<b-input-group-text
							><md-icon :icon="pickupTypeIcon"
						/></b-input-group-text>
					</template>
					<template #append>
						<b-button variant="primary" @click="pickupEdit = false">
							<b-spinner v-if="pickupLoading" small />
							<span v-else>X</span>
						</b-button>
					</template>
				</vue-typeahead-bootstrap>
			</b-form-group>

			<b-form-group class="text-center" label="." :class="{ 'col-1': !isMobile, 'col-12': isMobile }">
				<b-button
					v-if="!unableEdit"
					@click="swapPlaces"
					:size="isMobile ? 'md' : 'sm'"
					variant="info"
					><md-icon icon="swap_horiz"
				/></b-button>
			</b-form-group>

			<b-form-group
				:label="$t('bookings.destination')"
				style="width: 45%"
				:class="{ 'col-5': !isMobile, 'col-12': isMobile, 'mb-2': isMobile }"
			>
				<b-input-group v-if="!dropoffEdit" size="sm">
					<b-form-input
						type="text"
						size="sm"
						v-model="model.dropoff.name"
						readonly
						required
					/>
					<template #prepend>
						<b-button
							v-if="dropoffLocationUrl"
							:href="dropoffLocationUrl"
							target="_blank"
							variant="success"
							size="sm"
						>
							<md-icon :icon="dropoffTypeIcon" />
						</b-button>
						<b-input-group-text v-else
							><md-icon :icon="dropoffTypeIcon"
						/></b-input-group-text>
					</template>
					<template #append>
						<b-button
							v-if="!unableEdit"
							variant="primary"
							@click="dropoffEdit = true"
							><md-icon icon="edit"></md-icon
						></b-button>
					</template>
				</b-input-group>

				<vue-typeahead-bootstrap
					v-else
					showAllResults
					size="sm"
					:placeholder="$t('global.search')"
					v-model="dropoffSearch"
					:serializer="place => place.name"
					:data="dropoffData"
					@hit="selected => setPlace('dropoff', selected)"
				>
					<template #suggestion="{ data, htmlText }">
						<span v-html="htmlText"></span><br /><small>{{
							data.address
						}}</small>
					</template>
					<template #prepend>
						<b-input-group-text
							><md-icon :icon="dropoffTypeIcon"
						/></b-input-group-text>
					</template>
					<template #append>
						<b-button
							variant="primary"
							@click="dropoffEdit = false"
						>
							<b-spinner v-if="dropoffLoading" small />
							<span v-else>X</span>
						</b-button>
					</template>
				</vue-typeahead-bootstrap>
			</b-form-group>
		</b-form-row>
		<template v-if="model.pickup.isAirport || model.dropoff.isAirport">
			<label class="col-form-label">
				{{ $t("bookings.dateTimeAndNumberOf") }}
				<strong v-if="model.pickup.isAirport">{{
					$t("bookings.arrivalFlight")
				}}</strong>
				<strong v-else>{{ $t("bookings.departureFlight") }}</strong>
			</label>
			<b-form-row class="mb-1">
				<b-col :class="{ 'col-4': !isMobile, 'col-12': isMobile, 'mt-2': isMobile, 'mb-2': isMobile }">
					<b-form-datepicker
						:locale="$root.store.state.currentUser.lang"
						:disabled="unableEdit"
						required
						size="sm"
						v-model="flightDateStr"
					/>
				</b-col>
				<b-col :class="{ 'col-3': !isMobile, 'col-6': isMobile, 'mt-2': isMobile, 'mb-2': isMobile }">
					<md-icon icon="access_time" :class="{'mr-2': isMobile }" />
					<vue-timepicker
						:disabled="unableEdit"
						required
						v-model="flightTimeStr"
						manual-input
						input-width="6em"
					></vue-timepicker>
				</b-col>
				<b-col :class="{ 'col-4': !isMobile, 'col-6': isMobile, 'mt-2': isMobile, 'mb-2': isMobile }">
					<b-input-group>
						<b-input-group-prepend v-if="flight.loading">
							<b-button>
								<b-spinner small />
							</b-button>
						</b-input-group-prepend>
						<b-input-group-prepend v-else>
							<b-button
								size="sm"
								variant="info"
								v-b-tooltip.hover
								:title="$t('bookings.clickFlightInfo')"
								v-if="isThereFlight"
								@click="openFlightData()"
							>
								<md-icon icon="info" />
							</b-button>
							<b-button
								size="sm"
								variant="danger"
								v-if="model.flightValidationStatus === 'none'"
								v-b-tooltip.hover
								:title="$t('bookings.flightNotValidate')"
								type="button"
							>
								<md-icon icon="info" />
							</b-button>
							<b-button
								size="sm"
								variant="success"
								v-else
								type="button"
								ref="tooltip-validation-status"
								v-b-tooltip.hover
								:title="
									'El vuelo ha sido validado por ' +
										model.flightValidationStatus
								"
							>
								<md-icon icon="check_circle" />
							</b-button>
						</b-input-group-prepend>

						<b-form-input
							:disabled="unableEdit"
							type="text"
							size="sm"
							v-model="model.flightNumber"
							required
						/>
						<!-- 						<b-input-group-append v-if="!unableEdit">
							<b-button @click="validateFlightData()" size="sm" variant="info">
								<b-spinner v-if="flight.loading" small />
								<span v-else>{{$t('bookings.validate')}}</span>
							</b-button>
						</b-input-group-append>
 -->
					</b-input-group>
				</b-col>
			</b-form-row>

			<b-form-row
				v-if="
					(flight.showUseFlightOption ||
						this.model.flightValidationStatus === 'user') &&
						!flight.loading
				"
			>
				<b-col cols="6" class="offset-6 text-right">
					<b-form-checkbox
						value="user"
						unchecked-value="none"
						v-model="model.flightValidationStatus"
					>
						Validación manual del vuelo
					</b-form-checkbox>
				</b-col>
			</b-form-row>
		</template>
		<label class="col-form-label">
			{{ $t("bookings.pickupDatetime") }}
		</label>
		<b-form-row class="mb-1">
			<b-col :class="{ 'col-4': !isMobile, 'col-12': isMobile }">
				<b-form-datepicker
					:locale="$root.store.state.currentUser.lang"
					:disabled="unableEdit"
					required
					size="sm"
					v-model="pickupDateStr"
				/>
			</b-col>
			<b-col :class="{ 'col-4': !isMobile, 'col-12': isMobile, 'mt-2': isMobile, 'mb-2': isMobile }">
				<md-icon icon="access_time" :class="{'mr-2': isMobile }" />
				<vue-timepicker
					:disabled="unableEdit"
					required
					v-model="pickupTimeStr"
					manual-input
					input-width="6em"
					class="mr-2"
				></vue-timepicker>
				<br />
				<span
					:class="
						timeBetwenFlightAndPickupAbs > 500 ? 'text-danger' : ''
					"
					v-if="timeBetwenFlightAndPickup"
				>
					<strong>{{ timeBetwenFlightAndPickupAbs }}</strong>
					{{ $t("global.minutes") }}
					<strong>{{
						timeBetwenFlightAndPickup >= 0
							? $t("global.before")
							: $t("global.after")
					}}</strong>
					{{ $t("global.ofFlight") }}
				</span>
			</b-col>
		</b-form-row>
		<hr />
		<b-form-row>
			<b-form-group :class="{ 'col-4': !isMobile, 'col-12': isMobile }" :label="$t('bookings.serviceType')">
				<b-form-select
					v-if="!unableEdit"
					size="sm"
					v-model="model.serviceTypeId"
					:options="serviceTypesOpts"
					required
				/>

				<b-form-input
					v-else
					disabled
					type="text"
					size="sm"
					:value="model.supplierServiceType.name"
				/>
			</b-form-group>
			<b-form-group
				v-if="operatedBy == 'supplier'"
				:class="{ 'col-4': !isMobile, 'col-12': isMobile }"
				:label="$t('bookings.salesChannel')"
			>
				<b-form-input
					:disabled="unableEdit"
					type="text"
					size="sm"
					v-model="model.supplierSalesChannel"
				/>
			</b-form-group>
			<b-form-group
				v-if="model.salesChannel"
				:class="{ 'col-4': !isMobile, 'col-12': isMobile }"
				:label="$t('bookings.salesChannel')"
			>
				<b-form-input
					:disabled="unableEdit"
					type="text"
					size="sm"
					v-model="model.salesChannel.name"
				/>
			</b-form-group>
			<b-form-group
				:class="{ 'col-4': !isMobile, 'col-12': isMobile }"
				:label="$t('bookings.salesChannelReference')"
			>
				<b-form-input
					:disabled="unableEdit"
					type="text"
					size="sm"
					v-model="model.salesChannelReference"
				/>
			</b-form-group>
		</b-form-row>
		<b-form-row>
			<b-form-group class="col-12" :label="$t('bookings.supplierNotes')">
				<b-textarea
					:disabled="unableEdit"
					size="sm"
					v-model="model.supplierNotes"
				/>
			</b-form-group>
		</b-form-row>
		<hr />

		<b-form-row>
			<b-button
				:block="isMobile"
				:size="isMobile ? '' : 'sm'"
				v-if="enableCopy"
				class="mr-auto"
				variant="dark"
				@click="emitClone"
				><md-icon icon="library_add" />
				{{ $t("global.copy") }}</b-button
			>

			<template v-if="model.status == 'active' || model.status == 'pending'">
				<template v-if="model.id > 0 && model.status != 'pending'">
					<b-button
						:size="isMobile ? '' : 'sm'"
						:block="isMobile"
						class="mr-1"
						@click="() => changeStatus('noShow')"
						:variant="
							$root.auxVars.transportServiceStatusClasses.noShow
						"
						><md-icon icon="perm_identityhelp_outline" />
						{{ $t("bookings.noShow") }}</b-button
					>
					<template v-if="!hasLimitedData">
						<b-button
							:size="isMobile ? '' : 'sm'"
							:block="isMobile"
							class="mr-1"
							@click="() => changeStatus('noProvided')"
							:variant="
								$root.auxVars.transportServiceStatusClasses
									.noProvided
							"
							><md-icon icon="directions_carhelp_outline" />
							{{ $t("bookings.noProvided") }}</b-button
						>
						<b-button
							:size="isMobile ? '' : 'sm'"
							:block="isMobile"
							class="mr-1"
							@click="() => changeStatus('canceled')"
							:variant="
								$root.auxVars.transportServiceStatusClasses
									.canceled
							"
							><md-icon icon="delete" />
							{{ $t("bookings.cancel") }}</b-button
						>
					</template>
					<b-button
						:size="isMobile ? '' : 'sm'"
						:block="isMobile"
						class="mr-1"
						@click="() => changeStatus('done')"
						:variant="
							$root.auxVars.transportServiceStatusClasses.done
						"
						><md-icon icon="done" />
						{{ $t("bookings.done") }}</b-button
					>
				</template>
				<b-button
					v-if="model.status == 'pending' && model.id > 0"
					:size="isMobile ? '' : 'sm'"
					:block="isMobile"
					class="mr-1"
					@click="() => changeStatus('active')"
					variant="success"
					><md-icon icon="done" />
					{{ $t("bookings.confirm") }}</b-button
				>
				<b-button
					v-if="model.id <= 0"
					:size="isMobile ? '' : 'sm'"
					variant="danger"
					:block="isMobile"
					@click="emitDelete"
					><md-icon icon="delete" />
					{{ $t("global.delete") }}</b-button
				>
			</template>

		</b-form-row>

		<!-- <div class="d-flex justify-content-end">
			<b-button
				v-if="enableCopy"
				class="mr-auto"
				variant="dark"
				@click="emitClone"
				><md-icon icon="library_add" />
				{{ $t("global.copy") }}</b-button
			>
			<template
				v-if="model.status == 'active' || model.status == 'pending'"
			>
				<template v-if="model.id > 0 && model.status != 'pending'">
					<b-button
						size="sm"
						class="mr-1"
						@click="() => changeStatus('noShow')"
						:variant="
							$root.auxVars.transportServiceStatusClasses.noShow
						"
						><md-icon icon="perm_identityhelp_outline" />
						{{ $t("bookings.noShow") }}</b-button
					>
					<template v-if="!hasLimitedData">
						<b-button
							size="sm"
							class="mr-1"
							@click="() => changeStatus('noProvided')"
							:variant="
								$root.auxVars.transportServiceStatusClasses
									.noProvided
							"
							><md-icon icon="directions_carhelp_outline" />
							{{ $t("bookings.noProvided") }}</b-button
						>
						<b-button
							size="sm"
							class="mr-1"
							@click="() => changeStatus('canceled')"
							:variant="
								$root.auxVars.transportServiceStatusClasses
									.canceled
							"
							><md-icon icon="delete" />
							{{ $t("bookings.cancel") }}</b-button
						>
					</template>
					<b-button
						size="sm"
						class="mr-1"
						@click="() => changeStatus('done')"
						:variant="
							$root.auxVars.transportServiceStatusClasses.done
						"
						><md-icon icon="done" />
						{{ $t("bookings.done") }}</b-button
					>
				</template>
				<b-button
					v-if="model.status == 'pending' && model.id > 0"
					size="sm"
					class="mr-1"
					@click="() => changeStatus('active')"
					variant="success"
					><md-icon icon="done" />
					{{ $t("bookings.confirm") }}</b-button
				>
				<b-button
					v-if="model.id <= 0"
					variant="danger"
					@click="emitDelete"
					><md-icon icon="delete" />
					{{ $t("global.delete") }}</b-button
				>
			</template>
		</div> -->


		<b-modal hide-footer ref="modal-view" size="lg" title="Datos de vuelo">
			<TemplateFlightItem
				:flight-data="model.flightValidationData"
				v-if="isThereFlight"
			></TemplateFlightItem>
		</b-modal>
		<SingleTransportServiceChangeStatus
			v-if="model.id > 0"
			:transport-service-id="model.id"
			:show.sync="showChangeStatusModal"
			:status="newStatus"
			@onUpdate="() => $emit('onUpdate')"
			:require-files="operatedBy === 'sc'"
		/>
		<SingleTransportServiceStatusEvidence
			v-if="model.id > 0"
			:transport-service-id="model.id"
			:show.sync="showStatusEvidenceModal"
			:status="model.status"
		/>
	</FormGroupBox>
</template>

<script>
import FormGroupBox from "../../helpers/FormGroupBox";
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import { debounce } from "debounce";
import VueTimepicker from "vue2-timepicker";
import TemplateFlightItem from "./FlightItem";
import SingleTransportServiceChangeStatus from "./SingleTransportServiceChangeStatus";
import SingleTransportServiceStatusEvidence from "./SingleTransportServiceStatusEvidence";
import Resize from "../../helpers/Resize.js";

export default {
	mixins: [Resize],
	props: {
		model: {
			type: Object,
			required: true
		},
		hasLimitedData: {
			type: Boolean,
			required: true
		},
		enableCopy: {
			type: Boolean,
			required: false,
			default: false
		},
		operatedBy: {
			type: String,
			required: true
		},
		enableAcceptService: {
			type: Boolean,
			required: false,
			default: true
		}
	},
	components: {
		FormGroupBox,
		VueTypeaheadBootstrap,
		VueTimepicker,
		TemplateFlightItem,
		SingleTransportServiceChangeStatus,
		SingleTransportServiceStatusEvidence
	},
	data() {
		return {
			newStatus: "active",
			showChangeStatusModal: false,
			showStatusEvidenceModal: false,
			showSupplierNotes: false,
			pickupEdit: false,
			dropoffEdit: false,
			pickupSearch: "",
			dropoffSearch: "",
			pickupLoading: false,
			dropoffLoading: false,
			pickupData: [],
			dropoffData: [],
			flight: {
				loading: false,
				showUseFlightOption: false,
				found: false
			}
			// viewModel:{
			// 	id:-1,
			// 	serviceNumber:'',
			// 	supplierConfirmed: false,
			// 	contactStatus:'noContacted',
			// 	status:'active',
			// 	pickupPlaceId:-1,
			// 	dropoffPlaceId:-1,
			// 	pickup:{ name: '' , isAirport:false},
			// 	dropoff:{ name: '', isAirport:false},
			// 	pickupDatetime:'',
			// 	flightNumber:'',
			// 	flightDatetime:'',
			// 	serviceTypeId: -1,
			// 	salesChannelId: -1,
			// 	salesChannel : { id:-1, text:'' },
			// 	supplierId:-1,
			// 	supplier : { id:-1, text:'' },
			// 	supplierReference:'',
			// 	supplierNotes:'',
			// 	salesChannelReference:'',
			// 	pointOfSale:{domain:null},
			// 	flightValidationStatus:'none',
			// 	flightValidationData:{},
			// },
		};
	},
	computed: {
		statusLabel() {
			return this.$t(`bookings.serviceStatusOpts.${this.model.status}`);
		},
		statusVariant() {
			return this.$root.auxVars.transportServiceStatusOpts.find(
				status => status.value === this.model.status
			).class;
		},
		routeUrl() {
			let originQuery;
			if (this.model.pickup.latitude && this.model.pickup.longitude) {
				originQuery = `${this.model.pickup.latitude},${this.model.pickup.longitude}`;
			} else {
				originQuery = encodeURIComponent(this.model.pickup.name);
			}
			let destinationQuery;
			if (this.model.dropoff.latitude && this.model.dropoff.longitude) {
				destinationQuery = `${this.model.dropoff.latitude},${this.model.dropoff.longitude}`;
			} else {
				destinationQuery = encodeURIComponent(this.model.dropoff.name);
			}
			return `https://www.google.com/maps/dir/?api=1&origin=${originQuery}&destination=${destinationQuery}&travelmode=driving`;
		},
		pickupLocationUrl() {
			if (this.model.pickup.latitude && this.model.pickup.longitude) {
				return `https://www.google.com/maps/search/?api=1&query=${this.model.pickup.latitude},${this.model.pickup.longitude}`;
			} else {
				return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
					this.model.pickup.name
				)}`;
			}
		},
		dropoffLocationUrl() {
			if (this.model.dropoff.latitude && this.model.dropoff.longitude) {
				return `https://www.google.com/maps/search/?api=1&query=${this.model.dropoff.latitude},${this.model.dropoff.longitude}`;
			} else {
				return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
					this.model.dropoff.name
				)}`;
			}
		},
		flightDatetime() {
			return this.$moment(this.model.flightDatetime);
		},
		pickupDatetime() {
			return this.$moment(this.model.pickupDatetime);
		},
		requireFlightDatas() {
			return this.model.pickup.isAirport || this.model.dropoff.isAirport;
		},
		timeBetwenFlightAndPickupAbs() {
			return Math.abs(this.timeBetwenFlightAndPickup);
		},
		timeBetwenFlightAndPickup() {
			if (
				this.flightDatetime.isValid() &&
				this.pickupDatetime.isValid()
			) {
				return this.flightDatetime.diff(this.pickupDatetime, "minutes");
			}
			return false;
		},
		pickupTypeIcon() {
			let icon = "location_on";
			if (this.model.pickup.isAirport) icon = "flight";
			return icon;
		},
		dropoffTypeIcon() {
			let icon = "location_on";
			if (this.model.dropoff.isAirport) icon = "flight";
			return icon;
		},
		creationDatetimeStr() {
			return this.$moment(this.model.creationDatetime).format(
				"DD/MMMM/YYYY HH:mm:ss"
			);
		},
		unableEdit() {
			// return false
			return (
				this.hasLimitedData ||
				(this.model.status != "active" &&
					this.model.status != "pending")
			);
		},
		tripIcon() {
			if (this.model.pickup.isAirport) return "flight_land";
			//A2H
			else if (this.model.dropoff.isAirport) return "flight_takeoff";
			//H2A
			else return "place"; //P2P
		},
		flightLabel() {
			return this.model.pickup.isAirport ? "LLEGADA" : "SALIDA";
		},
		isNew() {
			return this.model.id == -1;
		},
		contactStatusOpts() {
			return this.$root.auxVars.transportServiceContactStatusOpts;
		},
		transportStatusOpts() {
			if (this.isNew) {
				const optios = [];
				const elm = this.$t("statusOptions");
				Object.keys(elm).forEach(item => {
					optios.push({ value: item, text: elm[item] });
				});
				return optios;
			} else {
				return this.$root.auxVars.transportServiceStatusOpts;
			}
		},
		serviceTypesOpts() {
			return this.$root.auxVars.serviceTypesOpts;
		},
		supplierOpts() {
			if (
				this.model.supplierId != -1 &&
				!this.$root.auxVars.suppliersOpts.find(
					st => st.value == this.model.supplierId
				)
			) {
				return [
					{
						value: this.model.supplier.id,
						text: this.model.supplier.name
					},
					...this.$root.auxVars.suppliersOpts
				];
			}
			return this.$root.auxVars.suppliersOpts;
		},
		pickupDateStr: {
			get: function() {
				let aux = this.$moment(this.model.pickupDatetime);
				return aux.isValid() ? aux.format("YYYY-MM-DD") : "";
			},
			set: function(v) {
				this.model.pickupDatetime = `${v} ${this.pickupTimeStr}`;
			}
		},
		pickupTimeStr: {
			get: function() {
				let aux = this.$moment(this.model.pickupDatetime);
				return aux.isValid() ? aux.format("HH:mm:00") : "00:00:00";
			},
			set: function(v) {
				this.model.pickupDatetime = `${this.pickupDateStr} ${v}`;
			}
		},
		flightDateStr: {
			get: function() {
				let aux = this.$moment(this.model.flightDatetime);
				return aux.isValid() ? aux.format("YYYY-MM-DD") : "";
			},
			set: function(v) {
				this.model.flightDatetime = `${v} ${this.flightTimeStr}`;
			}
		},
		flightTimeStr: {
			get: function() {
				let aux = this.$moment(this.model.flightDatetime);
				return aux.isValid() ? aux.format("HH:mm:00") : "00:00:00";
			},
			set: function(v) {
				this.model.flightDatetime = `${this.flightDateStr} ${v}`;
			}
		},
		domainPointOfsale() {
			return this.model.pointOfSale?.domain ?? false;
		},
		isThereFlight() {
			return (
				(this.model.flightValidationData?.number ?? "" !== "") &&
				this.model.flightValidationStatus === "api"
			);
		},
		supplierConfirmationStatus(){
			let text   = this.model.supplierConfirmation;
			let classe = "";
			switch(this.model.supplierConfirmation){
				case "rejected":
					text   = this.$t("bookings.notAccepted")
					classe = "danger"
					break;
				case "confirmed":
					text = this.$t("bookings.accepted")
					classe = "success"
					break;
			}
			return {text:text,class:classe};
		},
		isRideSelected(){
			return this.model.serviceNumber == this.$root.store.state.selectedServiceNumber && !this.$root.isEmpty(this.model.serviceNumber)
		}
	},
	methods: {
		changeStatus(newStatus) {
			this.newStatus = newStatus;
			this.showChangeStatusModal = true;
		},
		swapPlaces() {
			let aux = this.model.pickup;
			this.model.pickup = this.model.dropoff;
			this.model.dropoff = aux;
			aux = this.model.pickupPlaceId;
			this.model.pickupPlaceId = this.model.dropoffPlaceId;
			this.model.dropoffPlaceId = aux;
		},
		emitDelete() {
			// this.
			this.$emit("delete");
		},
		emitClone() {
			this.$emit("clone");
		},
		setPlace(attrName, place) {
			this.model[`${attrName}PlaceId`] = place.id;
			this.model[attrName] = place;
			this[`${attrName}Edit`] = false;
		},
		searchPlace(attrName, term) {
			if (term != "") {
				this[`${attrName}Loading`] = true;
				this.$root.api
					.post(`/places/search`, { term })
					.then(res => {
						console.log(res.data)
						this[`${attrName}Data`] = res.data;
						this[`${attrName}Loading`] = false;
					})
					.catch(err => {
						console.log(err);
					});
			}
		},
		validateFlightData() {
			this.model.flightValidationStatus = "user";
			this.model.flightValidationData = {};
			this.flight.loading = true;
			this.flight.found = false;
			this.flight.showUseFlightOption = true;
			let params = {
				flightNumber: this.model.flightNumber,
				flightDate: this.flightDateStr,
				pickupRef: this.model.pickup.type + "-" + this.model.pickup.id,
				dropoffRef:
					this.model.dropoff.type + "-" + this.model.dropoff.id
			};
			this.$root.api
				.get("/reservations/validate-flight", { params: params })
				.then(res => {
					if (res.data.valid) {
						this.flight.showUseFlightOption = false;
						this.flight.found = true;
						this.model.flightValidationStatus = "api";
						this.model.flightValidationData = res.data.flightData;
					} else {
						this.$root.showAlert("Numero de vuelo no es valido", {
							variant: "danger"
						});
					}
				})
				.finally(() => {
					this.flight.loading = false;
				});
		},
		openFlightData() {
			this.$refs["modal-view"].show();
		},
		hideFlightData() {
			this.$refs["modal-view"].hide();
		},

		saveSupplierConfirmation(option) {
			try {
				let msj = "";
				switch (option) {
					case "confirmed":
						msj = this.$t("bookings.confirmAcceptService");
						break;
					case "rejected":
						msj = this.$t("bookings.confirmRejectService");
						break;
					default:
						throw "Invalid option";
				}
				this.$bvModal
					.msgBoxConfirm(msj, {
						title: " ",
						size: "sm",
						buttonSize: "sm",
						okVariant: "success",
						okTitle: this.$t("global.yes"),
						cancelTitle: "No",
						footerClass: "p-2",
						hideHeaderClose: false,
						centered: true
					})
					.then(value => {
						if (value === true) {
							const query = {
								attrName: "supplierConfirmation",
								attrValue: option
							};
							this.$root.api
								.put(
									`/transport-services/${this.model.id}`,
									query
								)
								.then(() => {
									this.$root.showAlert(
										this.$t(
											`bookings.serviceUpdatedSuccessfully`
										)
									);
									this.$root.$emit("bv::refresh::table","reservations-index-list");
									this.$emit("onUpdate");
								})
								.catch(err => {
									this.$root.handleRequestError(err);
								})
								.finally(() => {
									//close();
								});
						}
					})
					.catch(err => {
						console.log(err);
						// An error occurred
					});
			} catch (err) {
				console.log(err);
			}
		}
	},
	mounted() {
		this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['serviceTypesOpts']})
	},
	watch: {
		// model: function(val){
		// 	this.updateViewModel(val);
		// },
		flightDateStr: function(val) {
			if (this.pickupDateStr == "") this.pickupDateStr = val;
		},
		flightTimeStr: function(val) {
			if (this.pickupTimeStr == "") this.pickupTimeStr = val;
		},
		pickupSearch: debounce(function(term) {
			this.searchPlace("pickup", term);
		}, 500),
		dropoffSearch: debounce(function(term) {
			this.searchPlace("dropoff", term);
		}, 500)
	}
};
</script>

<style>
.vbst-item {
	line-height: normal;
}
.list-group-item {
	padding: 0.2rem 0.8rem;
}
.list-group {
	padding-top: 2px;
}
.vue__time-picker input.display-time {
	height: 1.95em;
}
input.display-time.all-selected.disabled {
	background-color: #e9ecef;
	color: #495057;
}

.btnAcceptServiceMobile {

}


</style>
<style scoped>
.rideSelected{
	border: 3px solid green !important;
}
</style>
